export const appCred = {
  buildVersion: "1.0",
// appUrl: "http://localhost:33527/",
  appUrl: "https://mtiapi.aku.edu/",
  appServer: "VAKUDEVEX",
};